import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { openPopup } from '@appbase/util/popup-helper' 
import * as  dateHelper from '@appbase/util/date-helper'

@Component
export default class GnbSearch extends Vue {
    @Prop({type:Array}) orgList!: orgmap.UserItem[]
    @Prop({type:Array}) articleList!: gnbarticle.Article[]
    @Prop({type:Array}) workflowList!: Array<gnbTotalSearch.workflowSearchItems>
    @Prop({type:Array}) counts!: Array<number> //조직도, 게시판, 전자결재 순
    @Prop({type:String}) userLang!: string

    // searchselected: boolean = false

    // @Watch('selectedSearch')
    // onSelectedSearchChanged(newVal: boolean) {
    //     if (this.searchselected != newVal)
    //     this.$emit("onSelectedGnbSearch", newVal)
    // }

    fnDisplayDate(date: Date){
        let dtDate = new Date(date);
        return dtDate.toISOString().slice(0, 10);
    }

    fnVieArticle(articleId: number, boardId: number){
        openPopup('', `/BoardPopup/readPopup?SYSID=${boardId}&ARTICLEID=${articleId}`, {}, {
            width: 1024,
            height: 700,
            isFrame: this.isTeams
        });
    }

    getWorkflowTitle(item:gnbTotalSearch.workflowSearchItems){
        if(item.itemType.toLowerCase() == "document"){ //결재문서
             return `[결재문서] ${item.subject}`
            
        }else{ //양식
            return `[결재양식] ${item.applicationName}`
        }
         
    }

    convertDatetime(datetime:string){
 
        return dateHelper.uGetDateFormat_UTC("yyyy-MM-DD H:i:s",new Date(datetime))
    }

    onClickWorkflowItem(item:gnbTotalSearch.workflowSearchItems){
        
        let url =""
        const now = Date.now()
        if(item.itemType.toLowerCase() =="document"){
            url = `/workflow/page/form?apmid=${item.apmId}&appid=${item.applicationId}&storekey=${now}&pop=1`
        }else{
            url = `/workflow/page/form?appid=${item.applicationId}&storekey=${now}&pop=1`
        }
        openPopup(`formpoup_${now}}`, 
        url,{},
         {
            width: 1200,
            height: 760,
            scrollbars: 'no',
            menubar: 0,
            top: 0,
            left: 0,
            resizable: 1,
            noinvalidateUrl: true,
            isFrame: this.isTeams
        });
    }
}